import { Component, inject, OnInit } from '@angular/core';
import { PhitoAppComponent } from '../../../phito-core/src/lib/app/app/phito-app.component';
import { AppConfigService } from '../../../phito-core/src/lib/services/app-config.service';
import { LoginService } from '../../../phito-core/src/lib/modules/login/login.service';
import { MainMenuConfig } from '../../../phito-core/src/lib/app/app/main-menu';
import { LoggedIn } from '../../../phito-core/src/lib/modules/login/login';
import { PhitoSessionService } from '../../../phito-core/src/lib/services/phito-session.service';
import { BackendApiService } from '../../../phito-core/src/lib/services/backend-api.service';
import { DialogService } from '../../../phito-core/src/lib/services/dialog.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { SchuleService } from './schule.service';
import { Schule } from './schule-overview/schule';
import { SCHULE_ROUTES } from './schule.routes';
import { ADMINISTRATION_ROUTES, USER_ROUTES } from '../../../phito-core/src/lib/modules/administration/administration.routes';

@Component({
    selector: 'app-root',
    imports: [PhitoAppComponent, MatIconButton, MatIcon],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    private config = inject(AppConfigService);
    private loginService = inject(LoginService);
    protected sessionService = inject(PhitoSessionService);
    private api = inject(BackendApiService);
    private dialogService = inject(DialogService);
    protected schuleService = inject(SchuleService);

    title = 'phito. Schule';

    mainMenuConfig = new MainMenuConfig();

    options: any;
    loginType = '';
    hideSchuleSelector = false;

    constructor() {
        const loginService = this.loginService;

        this.options = { hasPhitomHierachy: false, version: this.config.getConfig().VERSION, mainMenuOpened: true };

        loginService.watchLoggedIn().subscribe({
            next: (loggedIn: LoggedIn) => {
                this.loginService.goToLandingPage(loggedIn, this.mainMenuConfig);
                this.setSelectionFields();
            },
        });
    }

    ngOnInit(): void {
        this.mainMenuConfig.setShowMenuName(false);
        this.setSelectionFields();

        this.mainMenuConfig.addMainMenuItemOnly(SCHULE_ROUTES.klassenraeume);
        this.mainMenuConfig.addMainMenuItemOnly(SCHULE_ROUTES.schulen);

        const beurteilungen = this.mainMenuConfig.addMainMenuItem('Beurteilungen', 'fact_check');
        beurteilungen.addSubMenu(SCHULE_ROUTES.beurteilungen);
        beurteilungen.addSubMenu(SCHULE_ROUTES.beurteilungspunkte);

        this.mainMenuConfig.addMainMenuItemOnly(SCHULE_ROUTES.mitarbeiter);

        const stammdaten = this.mainMenuConfig.addMainMenuItem('Stammdaten', 'database');
        stammdaten.addSubMenu(SCHULE_ROUTES.klassenraumtypen);
        stammdaten.addSubMenu(SCHULE_ROUTES.priorities);
        stammdaten.addSubMenu(SCHULE_ROUTES.umsetzer);

        this.mainMenuConfig.addMainMenuItemOnly(SCHULE_ROUTES.dashboard);

        const settings = this.mainMenuConfig.addMainMenuItem('Einstellungen', 'settings');
        settings.addSubMenu(ADMINISTRATION_ROUTES.dbvariables);
        settings.addSubMenu(ADMINISTRATION_ROUTES.pushNotificationsConfig);
        settings.addSubMenu(USER_ROUTES.users);
        settings.addSubMenu(USER_ROUTES.usergroups);
        settings.addSubMenu(ADMINISTRATION_ROUTES.companies);
        settings.addSubMenu(USER_ROUTES.roles);
        settings.addSubMenu(USER_ROUTES.userSessions);
        settings.addSubMenu(ADMINISTRATION_ROUTES.useractivities);
    }

    openSchuleDialog() {
        this.api.getAll<Schule>('schulen').subscribe((res) => {
            this.dialogService.selectOne('Schule auswählen', 'Schule', res.data, ['name']).subscribe((res1) => {
                if (res1.isConfirmed()) {
                    this.schuleService.schule.set(res1.getEntity().value);
                }
            });
        });
    }

    private setSelectionFields() {
        if (this.sessionService.loggedIn()) {
            this.api.getString('loginpage/type').subscribe((res) => {
                this.loginType = res;
                console.log(this.loginType);
                if (this.loginType === 'admin') {
                    this.hideSchuleSelector = false;
                } else if (this.loginType === 'schule') {
                    this.api.getAll<Schule>('schulen').subscribe((res1) => {
                        if (res1.data.length > 0) {
                            this.schuleService.schule.set(res1.data[0]);
                            if (res1.data.length === 1) {
                                this.hideSchuleSelector = true;
                            }
                        }
                    });
                } else if (this.loginType === 'mitarbeiter') {
                    this.api.getAll<Schule>('schulen').subscribe((res1) => {
                        if (res1.data.length > 0) {
                            this.schuleService.schule.set(res1.data[0]);
                            this.hideSchuleSelector = true;
                        }
                    });
                }
            });
        }
    }
}
